import { render, staticRenderFns } from "./reset-branch-stock.vue?vue&type=template&id=0163440e&scoped=true"
import script from "./reset-branch-stock.vue?vue&type=script&lang=js"
export * from "./reset-branch-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0163440e",
  null
  
)

export default component.exports